
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import StockAdjustmentModule from "@/store/modules/barcodeSystem/stockAdjustment";
import { StockAdjustmentListItem } from "@/models/api/barcodeSystem/stockAdjustments/get";

const stockAdjustmentModuleState = getModule(StockAdjustmentModule);

import draggable from "vuedraggable";

import RightClickMenu from "@/components/widgets/RightClickMenu.vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({
  components: {
    RightClickMenu,
    draggable
  }
})
export default class StockAdjustmentTable extends Vue {
  @Prop({ default: "table" })
  public id: string;

  @Prop({ default: "" })
  public containerClass: string;

  @Prop({ default: null })
  public tableField: Array<any>;

  @Prop({ default: null })
  public tableMenuItem: Array<any>;

  public rightClickLocation: any = null;
  public showHelp: boolean = false;
  public draggingData: boolean = false;

  get filterFields() {
    let filterFields = this.tableField.filter(
      field => field.hidden === false && field.key !== "selected"
    );
    return filterFields;
  }

  set filterFields(newValue) {
    this.$emit("updateFields", newValue);
  }

  get adjustments(): Array<StockAdjustmentListItem> {
    return stockAdjustmentModuleState.data;
  }

  get loading(): boolean {
    return stockAdjustmentModuleState.loading;
  }

  get selectedItemCount(): number {
    return stockAdjustmentModuleState.getSelectedItemCount;
  }

  get selectedItems(): Array<any> {
    return stockAdjustmentModuleState.getSelectedItems;
  }

 
  get totalItems() {
    if (stockAdjustmentModuleState.pageData) {
      const items = stockAdjustmentModuleState.pageData.totalItems;
      return items ? items : 0;
    } else {
      return 0;
    }
  }

  
  get currentSortAscending() {
    return stockAdjustmentModuleState.dataSortAscending;
  }
  get currentSort() {
    return stockAdjustmentModuleState.dataSortKey;
  }

  unselectAll() {
    let items = this.selectedItems;

    items.forEach(adjustment => {
      stockAdjustmentModuleState.switchSelectionStatus(adjustment.id);
    });
  }

  getComponentData(rowData) {
    return {
      on: {
        click: () => this.onRowClick(rowData),
        contextmenu: $event => this.onRightClicked(rowData, $event),
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }
  canMove() {
    return false;
  }
  putFeature() {
    return false;
  }
  sort(s) {
    this.$emit("sort", s);
  }

  onRightClicked(rowData, event) {
    event.preventDefault();
    if (!rowData.selected) stockAdjustmentModuleState.switchSelectionStatus(rowData.id);

    this.rightClickLocation = { x: event.x, y: event.y };
  }

  onDoubleClicked(data) {
    stockAdjustmentModuleState.viewStockAdjustmentShortcutAction( {selectedItems: [data]});
  }

  onRowClick(rowData) {
    stockAdjustmentModuleState.switchSelectionStatus(rowData.id);

    this.clearRightClick();
  }
  clearRightClick() {
    this.rightClickLocation = null;
    this.draggingData = false;
  }
  clickMenu(item) {
    let items = this.selectedItems;
    this.$store.dispatch(item.action, { selectedItems: items });
    this.clearRightClick();
  }
  onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
    if (
      Math.ceil(scrollTop) + 1 + clientHeight >= scrollHeight &&
      !this.loading &&
      stockAdjustmentModuleState.pageData.totalItems > this.adjustments.length
    ) {
      this.$emit("loadMoreData");
    }
  }

  getFieldClass(field, data) {
    var fieldClass = null;
    if (field.textAlign) {
      switch (field.textAlign) {
        case "right":
          fieldClass = "text-right";
          break;
        case "left":
          fieldClass = "text-left";
          break;
        case "center":
          fieldClass = "text-center";
          break;
        default:
          break;
      }
    }

    if(field.noWrap)
    {
      fieldClass += " text-nowrap";
    }

    return fieldClass;
  }
  
  getValue(object, path) {
    if (!path) return;
    return path.split(".").reduce((r, k) => (r ? r[k] : ""), object);
  }
}
